export enum PresentationFileStatus {
	Complete = 'Complete',
	Uploading = 'Uploading',
	UploadingFailed = 'UploadFailed',
	ProcessingImages = 'ProcessingImages',
	ProcessingFailed = 'ProcessingImagesFailed'
}
